export const STORAGE_ACCOUNT = process.env.REACT_APP_STORAGE_ACCOUNT;
export const DATA_FILES_FOLDER = process.env.REACT_APP_DATA_FILES_FOLDER;
export const DOCUMENTS_FOLDER = process.env.REACT_APP_DOCUMENTS_FOLDER;
export const APPLICATION_FORM_FOLDER = process.env.REACT_APP_APPLICATION_FORM_FOLDER;
export const FRONT_DOOR_URL = process.env.REACT_APP_FRONT_DOOR_URL;
export const HEARINGS_FILE_NAME = process.env.REACT_APP_HEARINGS_FILE_NAME;
export const APPEALS_FILE_NAME = process.env.REACT_APP_APPEALS_FILE_NAME;